import { base_colorAction } from 'ext-ui/style/colors'
import React, { SVGProps } from 'react'

const SvgSidenavRulesAndWorkflowsActive = (
  props: SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <g clipPath="url(#clip0_1637_38935)">
      <path
        d="M10 3.33333L12.4 5.73333C14 1.53333 18.4667 5.99999 14.2667 7.59999L16.6667 10L14.2667 12.4C12.6667 8.2 8.20004 12.6667 12.4 14.2667L10 16.6667L7.60004 14.2667C6.00004 18.4667 1.53337 14 5.73337 12.4L3.33337 10L5.73337 7.59999C7.33337 11.8 11.8 7.33333 7.60004 5.73333L10 3.33333Z"
        fill={props.fill || base_colorAction}
        stroke={props.stroke || base_colorAction}
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1637_38935">
        <rect width="16" height="16" fill="white" transform="translate(2 2)" />
      </clipPath>
    </defs>
  </svg>
)
export default SvgSidenavRulesAndWorkflowsActive
